<template>
    <div id="productDetailsWrapper">
        <media-only desktop>
            <USPBanner v-if="uspBannerVisible" />
        </media-only>
        <component
            :is="component"
            v-bind="{
                product,
                marker,
                extraServicesAndInfos,
                relatedProducts,
                hotelProducts,
                teaser,
                productDetails,
                hotelDetails,
                isOtherProduct
            }"
        />
        <ExitIntentNewsletter v-if="$store.state.globalMeta.newsletterFormEnabled" />
    </div>
</template>

<script>
import Marker from '@/models/Marker';
import Grid from '@/models/Grid';
import getHead from '@/mixins/getHead';
import ProductDetailsMobile from '@/components/product/ProductDetailsMobile';
import ProductDetailsDesktop from '@/components/product/ProductDetailsDesktop';
import extraScriptCode from '@/mixins/extraScriptCode';
import advertisable from '@/mixins/advertisable';
import fetchResource from '@/utils/fetchResource';
import ExitIntentNewsletter from '@/components/modals/ExitIntentNewsletter';
import ExitIntent from '@/components/utility/ExitIntent';
import constructProductSchema from '@/utils/constructProductSchema';

export default {
    name: 'Product',
    layout: ({ layout }) => layout,
    mixins: [getHead, extraScriptCode('product'), advertisable('product')],
    async fetch(context) {
        await fetchResource(context, context.store.dispatch('getProduct', context.params.productId));
    },
    components: {
        ExitIntent,
        ExitIntentNewsletter,
        ProductDetailsDesktop,
        ProductDetailsMobile,
        NettoProductDetails: () =>
            import(
                /* webpackChunkName: "netto-product-details" */ '@/themes/nettovorteilswelt/components/product/NettoProductDetails'
            ),
    },
    head() {
        return this.getHead(
            {
                pageTitle: this.product.metaTitle,
                noindex: this.productDetails.noindex,
                keywords: this.product.metaKeywords,
                metaDescription: this.product.metaDescription,
                canonicalUrl: this.product.canonicalUrl,
                imageUrl: this.productDetails.teaserImageUrl,
                pageType: 'product'
            },
            this.schemaOrg
        );
    },
    computed: {
        schemaOrg() {
            return constructProductSchema(this.product, this.productDetails.productCategory);
        },
        component() {
            if (this.$store.state.theme === 'nettovorteilswelt') {
                return 'NettoProductDetails';
            }
            // if (this.$store.state.theme === 'mivo' && this.productDetails.auctionOffer) {
            //     return 'MivoProductDetails';
            // }
            if (this.$root.isMobile) {
                return 'ProductDetailsMobile';
            }
            return 'ProductDetailsDesktop';
        },
        product() {
            return this.$store.state.product;
        },
        productDetails() {
            return this.product.productDetails || {};
        },
        hotelDetails() {
            return this.product.hotelDetails || {};
        },
        teaser() {
            //now for desktop. For mobile teaser should be combined with images
            const { teaserImageUrl } = this.productDetails;
            return { imageUrl: teaserImageUrl };
        },
        marker() {
            const [lat, lng] = this.$getSafe(this.productDetails, 'latLon') || [];
            const blockToEntry = {
                ...this.productDetails,
                imageUrl: this.$getSafe(this.productDetails, 'teaserImageUrl'),
                //minimumPrice: this.$getSafe(this.productDetails, 'minimumPrice.price'),
                //minimumPerPersonPrice: this.$getSafe(this.productDetails, 'minimumPrice.perPersonPrice'),
                hotelName: this.productDetails.hotel,
                text: this.productDetails.title,
                type: 'product',
                link: {
                    productId: this.productDetails.id,
                    webnames: [this.productDetails.hotelWebname, this.productDetails.webname]
                }
            };
            return new Marker(lat, lng, blockToEntry);
        },
        extraServicesAndInfos() {
            if (!this.product.productDetails) {
                return [];
            }
            return [...this.productDetails.extraServices, ...this.productDetails.additionalHotelInfos];
        },
        relatedProducts() {
            return new Grid(this.$t('ProductDetails.relatedOffers.header'), this.product.relatedProducts);
        },
        hotelProducts() {
            return new Grid(this.$t('ProductDetails.hotelOffers.header'), this.product.otherProductsOfHotel);
        },
        isOtherProduct() {
            return (
                this.productDetails.hotelVoucherType === 'ExternalTravelVoucher' ||
                this.productDetails.hotelVoucherType === 'OtherExternalVoucher'
            );
        }
    },
    methods: {
        sendGTMEvent() {
            this.$gtm && this.productDetails && this.$gtm.pushProductDetailsData(this.productDetails);
        }
    },
    beforeMount() {
        this.sendGTMEvent();
    }
};
</script>
